class ResumeHelper {
  static getDefaults() {
    return {
      // common fields
      gpa: null,
      gpa_raw: null,
      gpa_raw_scale: null,
      class_rank: null,
      high_school: '',
      high_school_grade_level: null,
      summer_school_or_exchange_programs: [],
      courses: [],
      undergraduate_courses: [],
      honors: [],
      papers: [],
      extracurricular_activities: [],
      name: '',
      languages: [],
      interested_career_or_major: '',
      specialties_and_certifications: [],
      patents: [],
      target_countries_or_regions: [],
      interested_majors: [],
      preference_tags: {},

      // new undergraduate fields
      internship_and_work_experiences: [],
      research_and_project_experiences: [],
      honors_and_awards: [],
      other_specialties_activities_experiences: [],
    };
  }
}

export default ResumeHelper;
